export const SEGMENTIO = {
  CLICKED_PROCEED: 'Clicked_Proceed',
  CONFIRM_PROCEED: 'Confirm_Proceed',
  ERROR_PROCEED: 'Error_Proceed',
  STARTED: 'Started',
  SUBMITTED: 'Submitted',
  TIME_EXPIRED: 'Time_Expired',
  COMPLETED: 'Completed',
  PASSED: 'Passed',
  GO_TO_DETAIL: 'GoToDetail',
  MAX_NUM_RESPONSE: 'MaxNum_response',
  ALGO_PASTE_DETECTED: 'Algo_PasteDetected',
  SIGNUP_SUCCESS: 'Signup_Success',
  SIGNUP_ERROR: 'Signup_Error',
  SURVEY1_SUBMIT: 'Survey1_submit',
  SURVEY2_SUBMIT: 'Survey2_submit',
  JSTEST_1: 'JS_test_1',
  JSTEST_SUBMIT: 'JS_test_submit',
  REDIRECT_TO_DASHBOARD: 'Redirecting_to_dashboard',
  REDIRECT_TO_ONBOARDING: 'Redirecting_to_profile_onboarding',
  VIDE_PLAY: 'Video_play',
  JOB_DETAILS: 'Job_details',
  JOB_APPLY_SUCCESS: 'Job_apply_success',
  JOB_APPLY_FAIL: 'Job_apply_fail',
  UPLOAD_RESUME: 'Upload_Resume',
  CLICKED_CONTINUE: 'Clicked_Continue',
  CONFIRM_CONTINUE: 'Confirm_Continue',
  ERROR_CONTINUE: 'Error_Continue',
  RESUME_UPLOAD: 'Resume_upload',
  RESUME_UPLOAD_ERROR: 'RESUME_UPLOAD_ERROR',
  MEETING_BOOKED: 'MeetingBooked',
  MCQ_Quit_TimerPaused: 'MCQ_Quit_TimerPaused',
  MCQ_Quit_TimerPaused_Cancel: 'MCQ_Quit_TimerPaused_Cancel',
  PROFILE_COMPLETED: 'Profile_Completed',
  GOOGLE_SSO_INCOGNITO: 'GOOGLE_SSO_INCOGNITO',
  ABTEST_NO_ONBOARDING_PROFILE: 'ABTEST_NO_ONBOARDING_PROFILE',
  ABTEST_YES_ONBOARDING_PROFILE: 'ABTEST_YES_ONBOARDING_PROFILE',
  ABTEST_NOT_PARTICIPATE_ONBOARDING_PROFILE: 'ABTEST_NOT_PARTICIPATE_ONBOARDING_PROFILE',
  ONBOARDING_PROFILE_STEP_1_COMPLETED: 'ONBOARDING_PROFILE_STEP_1_COMPLETED',
  ONBOARDING_PROFILE_STEP_2_COMPLETED: 'ONBOARDING_PROFILE_STEP_2_COMPLETED',
  ONBOARDING_PROFILE_STEP_3_COMPLETED: 'ONBOARDING_PROFILE_STEP_3_COMPLETED',
  ONBOARDING_PROFILE_STEP_4_COMPLETED: 'ONBOARDING_PROFILE_STEP_4_COMPLETED',
  CALENDAR_OPEN: 'CALENDAR_OPEN',
  CALENDAR_CONFIRM_BOOK: 'CALENDAR_CONFIRM_BOOK',
  CALENDAR_BOOK_FAIL: 'CALENDAR_BOOK_FAIL',
  CALENDAR_BOOK_SUCCESS: 'CALENDAR_BOOK_SUCCESS',
  CALENDAR_CANCEL_BOOKED_EVENT_CLICK: 'CALENDAR_CANCEL_BOOKED_EVENT_CLICK',
  CALENDAR_CANCEL_BOOKED_EVENT_SUCCESS: 'CALENDAR_CANCEL_BOOKED_EVENT_SUCCESS',
  CALENDAR_CANCEL_BOOKED_EVENT_FAIL: 'CALENDAR_CANCEL_BOOKED_EVENT_FAIL',
  // Profile Events
  PROFILE_ADD_EDUCATION_EVENT_CLICKED: 'PROFILE_ADD_EDUCATION_EVENT_CLICKED',
  PROFILE_SAVE_EDUCATION_EVENT_CLICKED: 'PROFILE_SAVE_EDUCATION_EVENT_CLICKED',
  PROFILE_CANCEL_EDUCATION_EVENT_CLICKED: 'PROFILE_CANCEL_EDUCATION_EVENT_CLICKED',
  PROFILE_ADD_WORK_EXPERIENCE_EVENT_CLICKED: 'PROFILE_ADD_WORK_EXPERIENCE_EVENT_CLICKED',
  PROFILE_SAVE_WORK_EXPERIENCE_EVENT_CLICKED: 'PROFILE_SAVE_WORK_EXPERIENCE_EVENT_CLICKED',
  PROFILE_CANCEL_WORK_EXPERIENCE_EVENT_CLICKED: 'PROFILE_CANCEL_WORK_EXPERIENCE_EVENT_CLICKED',
  PROFILE_ADD_PROJECT_EVENT_CLICKED: 'PROFILE_ADD_PROJECT_EVENT_CLICKED',
  PROFILE_SAVE_PROJECT_EVENT_CLICKED: 'PROFILE_SAVE_PROJECT_EVENT_CLICKED',
  PROFILE_CANCEL_PROJECT_EVENT_CLICKED: 'PROFILE_CANCEL_PROJECT_EVENT_CLICKED',
  PROFILE_ADD_PUBLICATION_EVENT_CLICKED: 'PROFILE_ADD_PUBLICATION_EVENT_CLICKED',
  PROFILE_SAVE_PUBLICATION_EVENT_CLICKED: 'PROFILE_SAVE_PUBLICATION_EVENT_CLICKED',
  PROFILE_CANCEL_PUBLICATION_EVENT_CLICKED: 'PROFILE_CANCEL_PUBLICATION_EVENT_CLICKED',
  PROFILE_ADD_CERT_AWARD_EVENT_CLICKED: 'PROFILE_ADD_CERT_AWARD_EVENT_CLICKED',
  PROFILE_SAVE_CERT_AWARD_EVENT_CLICKED: 'PROFILE_SAVE_CERT_AWARD_EVENT_CLICKED',
  PROFILE_CANCEL_CERT_AWARD_EVENT_CLICKED: 'PROFILE_CANCEL_CERT_AWARD_EVENT_CLICKED',
  /* ONBOARDING */
  ONBOARDING_PAGE_1: 'ONBOARDING_PAGE_1',
  ONBOARDING_PAGE_2: 'ONBOARDING_PAGE_2',
  ONBOARDING_PAGE_2_SAVE_INFO: 'ONBOARDING_PAGE_2_SAVE_INFO',
  ONBOARDING_PAGE_2_SAVE_INFO_FAIL: 'ONBOARDING_PAGE_2_SAVE_INFO_FAIL',
  HOME_PAGE: 'HOME_PAGE',
  TEST_PAGE: 'TEST_PAGE',
  START_SENIORITY_ASSESSMENT: 'START_SENIORITY_ASSESSMENT',
  CONTINUE_SENIORITY_ASSESSMENT: 'CONTINUE_SENIORITY_ASSESSMENT',
  REFERRAL_VISIT: 'REFERRAL_VISIT'
};
